export enum DrugInteractionActionsEnum {
  SET_HELP = '@drugInteraction/SET_HELP',
  SET_RATING = '@drugInteraction/SET_RATING',
  SET_ACTIVE_INGREDIENTS = '@drugInteraction/SET_ACTIVE_INGREDIENTS',
  SET_INTERACTIONS = '@drugInteraction/SET_INTERACTIONS',
}
